<form [formGroup]="argumentsForm" autocomplete="off">
  <div>
    <div class="argument-title-container" i18n="@@promptArgumentsDescription">
      Please fill in the following arguments for the selected prompt.
    </div>
  </div>
  @for(argument of promptArguments; track argument){
  <div class="form-controls-padding header-padding">
    <mat-form-field appearance="outline" hideRequiredMarker="true">
      <mat-label
        >{{ argument.name | firstCapitalLetterRemoveUnderscores }}
        <span> @if (argument.required) {*} </span>
      </mat-label>
      <input
        matInput
        type="text"
        placeholder="Value for {{
          argument.name | firstCapitalLetterRemoveUnderscores
        }}"
        i18n-placeholder="@@promptArgumentPlaceholder"
        [formControlName]="argument.name"
      />
      @if (emptyArgument(argument.name)) {
      <mat-error i18n="@@promptArgumentRequiredError">
        Please enter a value for
        {{ argument.name | firstCapitalLetterRemoveUnderscores }}
        argument</mat-error
      >
      }
    </mat-form-field>
  </div>
  }
</form>
